import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/CreateDb.css";
import ss from "../assets/images/SS.png";
import contact from "../assets/images/contact.png";
import {
  HiBuildingOffice2,
  HiFolderOpen,
  HiCog6Tooth,
  HiKey,
  HiCircleStack,
} from "react-icons/hi2";
import CreateCompany from "../components/Cdb/CreateCompany";
import OpenCompany from "../components/Cdb/OpenCompany";
import CustomerCodeVerification from "../components/Cdb/CustomerCodeVerification";
import PasswordVerification from "../components/verificators/PasswordVerification";
import EmailVerification from "../components/verificators/EmailVerification";

function CreateDb() {
  const navigate = useNavigate();
  const [showcreateCompanyModal, setShowCreateCompanyModal] = useState(false);
  const [showopenCompanyModal, setShowopenCompanyModal] = useState(false);
  const [showcdbsettingsModal, setShowcdbsettingsModal] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [pendingAction, setPendingAction] = useState(null); // "CREATE", "SETTINGS", "UPDATE"

  const [showDbUpdate, setShowDbUpdate] = useState(false);
  const [secretClickCount, setSecretClickCount] = useState(0);
  const secretClickTimerRef = useRef(null);

  const handleSecretClick = () => {
    if (secretClickTimerRef.current) {
      clearTimeout(secretClickTimerRef.current);
    }
    const newCount = secretClickCount + 1;
    if (newCount >= 3) {
      setShowDbUpdate(true);
      openDbUpdate();
      setSecretClickCount(0);
    } else {
      setSecretClickCount(newCount);
      secretClickTimerRef.current = setTimeout(() => {
        setSecretClickCount(0);
      }, 2000);
    }
  };

  const [showEmailVerification, setShowEmailVerification] = useState(false);
  const [emailVerificationData, setEmailVerificationData] = useState(null);
  const [emailVerificationOtp, setEmailVerificationOtp] = useState("");
  const [emailVerificationCallback, setEmailVerificationCallback] = useState(null);

  const [modalCounter, setModalCounter] = useState(1000);
  const [zIndices, setZIndices] = useState({});

  const opencdbSettings = () => {
    setZIndices((prev) => ({ ...prev, cdbSettings: modalCounter }));
    setModalCounter((prev) => prev + 1000);
    setShowcdbsettingsModal(true);
  };

  const openRegistrationModal = () => {
    setZIndices((prev) => ({ ...prev, createCompany: modalCounter }));
    setModalCounter((prev) => prev + 1000);
    setPendingAction("CREATE");
    setShowPasswordModal(true);
  };

  const opencompanyModal = () => {
    setZIndices((prev) => ({ ...prev, openCompany: modalCounter }));
    setModalCounter((prev) => prev + 1000);
    setShowopenCompanyModal(true);
  };

  const openDbUpdate = () => {
    setPendingAction("UPDATE");
    setShowPasswordModal(true);
  };

  const handleClearcustomerCode = () => {
    const confirmClear = window.confirm("Do you want to clear the customer code?");
    if (confirmClear) {
      localStorage.removeItem("customerCode");
      alert("Cleared");
    }
  };

  const handlePasswordSuccess = () => {
    setShowPasswordModal(false);
    if (pendingAction === "CREATE") {
      setShowCreateCompanyModal(true);
    } else if (pendingAction === "UPDATE") {
      navigate("/dbupdate");
    }
    setPendingAction(null);
  };

  return (
    <div className="CreateDbRoot">
      <div className="CreateDbnavbar">
        <button
          type="button"
          className="CreateDbnavbarBtn"
          onClick={openRegistrationModal}
        >
          <span className="btn-icon-tile btn-tile-blue">
            <HiBuildingOffice2 />
          </span>
          <span>Create Company</span>
        </button>
        <button
          type="button"
          className="CreateDbnavbarBtn"
          onClick={opencompanyModal}
        >
          <span className="btn-icon-tile btn-tile-amber">
            <HiFolderOpen />
          </span>
          <span>Open Company</span>
        </button>
        <button
          type="button"
          className="CreateDbnavbarBtn"
          onClick={opencdbSettings}
        >
          <span className="btn-icon-tile btn-tile-indigo">
            <HiCog6Tooth />
          </span>
          <span>Settings</span>
        </button>
        <button
          type="button"
          className="CreateDbnavbarBtn"
          onClick={handleClearcustomerCode}
        >
          <span className="btn-icon-tile btn-tile-rose">
            <HiKey />
          </span>
          <span>Clear Code</span>
        </button>
        {showDbUpdate ? (
          <button
            type="button"
            className="CreateDbnavbarBtn revealed"
            onClick={openDbUpdate}
          >
            <span className="btn-icon-tile btn-tile-emerald">
              <HiCircleStack />
            </span>
            <span>DB Update</span>
          </button>
        ) : (
          <div
            className="CreateDbSecretSpot"
            onClick={handleSecretClick}
            aria-hidden="true"
          />
        )}
      </div>
      <div className="shergoldheaddivcdb">
        <div className="shergoldheadcdb">
          <span>SherGold</span>
          <span className="ml-2 erp-gold-sloped-shape text-[24px] md:text-[30px] 2xl:text-[36px]">
            <span className="erp-gold-sloped-inner">
              <span className="erp-gold-sloped-text">ERP</span>
            </span>
          </span>
        </div>
        <label className="shergoldtagcdb">
          A Complete Accounting &amp; Inventory Package
        </label>
      </div>
      <footer className="CreateDbfooter">
        <div className="CreateDbfooterCompany">
          <img src={ss} alt="SherSoft" className="CreateDbfooterLogo" />
          <div className="CreateDbfooterCompanyContent">
            <span className="CreateDbfooterCompanyName">SherSoft</span>
            <span className="CreateDbfooterCompanySubtitle">Software Company</span>
            <a
              href="https://www.shersoftware.com"
              target="_blank"
              rel="noopener noreferrer"
              className="CreateDbfooterCompanyDetail"
            >
              www.shersoftware.com
            </a>
            <a href="tel:9847997755" className="CreateDbfooterCompanyDetail">
              PH: 9847997755
            </a>
            <a
              href="mailto:shersoftware@gmail.com"
              className="CreateDbfooterCompanyDetail"
            >
              Email: shersoftware@gmail.com
            </a>
          </div>
        </div>

        <div className="CreateDbfooterContactHub">
          <div className="CreateDbContactGridWrapper">
            <div className="CreateDbContactRow">
              <img src={contact} alt="PH" className="CreateDbContactIcon" />
              <div className="CreateDbContactNumbersGrid">
                <span>7560889991</span>
                <span>7560889994</span>
                <span>7560889997</span>
                <span>7560880900</span>
              </div>
            </div>

            <div className="CreateDbContactRow">
              <img src={contact} alt="PH" className="CreateDbContactIcon" />
              <div className="CreateDbContactNumbersGrid">
                <span>7560889992</span>
                <span>7560889995</span>
                <span>7560889998</span>
                <span>7560888930</span>
              </div>
            </div>

            <div className="CreateDbContactRow">
              <img src={contact} alt="PH" className="CreateDbContactIcon" />
              <div className="CreateDbContactNumbersGrid">
                <span>7560889993</span>
                <span>7560889996</span>
                <span>7560889970</span>
                <span>7560888669</span>
              </div>
            </div>
          </div>

          <div className="CreateDbBackupNotice">
            Please take Backup to External media otherwise "Shersoft" have no responsibility for data loss
          </div>
        </div>
      </footer>
      {showPasswordModal && (
        <PasswordVerification
          onSuccess={handlePasswordSuccess}
          onClose={() => setShowPasswordModal(false)}
          zIndex={modalCounter}
        />
      )}
      {showcreateCompanyModal && (
        <CreateCompany
          onClose={() => setShowCreateCompanyModal(false)}
          zIndex={zIndices["createCompany"]}
        />
      )}
      {showopenCompanyModal && (
        <OpenCompany
          onClose={() => setShowopenCompanyModal(false)}
          zIndex={zIndices["openCompany"]}
        />
      )}
      {showcdbsettingsModal && (
        <CustomerCodeVerification
          onClose={() => setShowcdbsettingsModal(false)}
          zIndex={zIndices["cdbSettings"]}
          onVerifyCode={(compData, otp, callback) => {
            setEmailVerificationData(compData);
            setEmailVerificationOtp(otp);
            setEmailVerificationCallback(() => callback);
            setShowEmailVerification(true);
          }}
        />
      )}
      {showEmailVerification && (
        <EmailVerification
          onClose={() => setShowEmailVerification(false)}
          data={emailVerificationData}
          generatedOtp={emailVerificationOtp}
          onVerified={(e) => {
            if (emailVerificationCallback) {
              emailVerificationCallback(e);
            }
          }}
          zIndex={modalCounter + 2000}
        />
      )}
    </div>
  );
}

export default CreateDb;